import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { forkJoin, Observable, of } from 'rxjs';
import { map, share } from 'rxjs/operators';
import { Customer, CustomerInfo, Restrictions, RestrictionTypes } from './Customer';
import { environment } from '../../../../environments/environment'

@Injectable()
export class CustomerService {
  private customerURL = `${environment.defaultURL}/v2/customer/`;
  private restrictionURL = `${environment.defaultURL}/v2/proxy/`;
  constructor(private http: HttpClient) {
  }

  getCustomer(accountNumber : string, customerName : string, zipcode : string, action : string): Observable<Customer>{
    let url = `${this.customerURL}find`
    let queryParams = { account: accountNumber, name: customerName, zip: zipcode, optaction: action }
    return this.http.get<Customer>(url,{params:queryParams});
  }

  getCustomerDetails(accountNumber : string, customerName : string, zipcode : string, action : string): Observable<Customer>{
    let url = `${this.customerURL}getDetails`
    const httpOptions = { 
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: { accountId: accountNumber, name: customerName, zip: zipcode, optaction: action } 
    };
    return this.http.get<Customer>(url, httpOptions).pipe(share());
  }
 
  isCustomerRestricted(contactIds: string[],action:string): Observable<Restrictions[]> {
        //for POST
        let url = `${this.restrictionURL}restriction`;
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
        const chunks = this.chunkArray(contactIds, 50);
         const calls = chunks.map(ids => {
             let request: CustomerInfo = {
                 cca: environment.ccaName,
                 action: action,
                 contactIds: ids
             }
             return this.http.post<Restrictions[]>(url, request, httpOptions);
         });
        return forkJoin(calls).pipe(map(r => {
          return r.reduce(this.populate, [])
        }));
    }

    private populate(result: Restrictions[],apiResult: Restrictions[]): Restrictions[]
    {
      apiResult.forEach(restriction => {
        const restrictionInResult = result.find(r => r.restrictionType == restriction.restrictionType);
        if(restrictionInResult == null) {
          result.push(restriction);
        } else if (!restrictionInResult.isRestricted && restriction.isRestricted){
          restrictionInResult.isRestricted = restriction.isRestricted;
        }
      });
      return result;
    }

  private chunkArray(array: string[], chunkSize: number): any[][] {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  }
}
